import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function BlogPost() {

  var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],

    ['blockquote', 'code-block'],

    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],

    [{ 'align': [] }],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    ['link', 'image'],

    [{ 'script': 'sub' }, { 'script': 'super' }],
  ];

  return (
    <>
      <Breadcrumb title="Blog Post" path="Blog / Blog Post" />
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 flex flex-col gap-20'>
        <div className='form-group'>
          <input type='text' id='blogTitle' name='blogTitle' placeholder='Enter blog title' />
        </div>
        <div className='form-group'>
          <select name="blogCategory" id="blogCategory">
            <option value="blogCategory">Blog Category</option>
            <option value="webDesign">Web Design</option>
            <option value="photography">Photography</option>
            <option value="technology">Technology</option>
            <option value="lifestyle">Lifestyle</option>
            <option value="sports">Sports</option>
          </select>
        </div>
        <div className='form-group'>
          <input type='file' id='blogImage' name='blogImage' className='cursor-pointer' />
        </div>
        <ReactQuill modules={{ toolbar: toolbarOptions }} placeholder="hi, we are Summernote" className='bg-bg-light' />
        <button className='btn btn-primary'>
          Post
        </button>
      </div>
    </>
  )
}
